<template>
  <div>
    <CCard>
      <CCardHeader>
        Integration Clients
        <CButton size="sm" color="success" class="float-right" @click="showCreate = true">Add client</CButton>
      </CCardHeader>
      <CCardBody>
        <CAlert color="warning">API keys and assertion secrets are shown once. Store them only in the consuming site's backend secret store.</CAlert>
        <CAlert v-if="oneTimeSecret" color="success" dismissible>
          <strong>{{ oneTimeLabel }} (copy now):</strong><br><code>{{ oneTimeSecret }}</code>
        </CAlert>
        <div v-for="client in clients" :key="client.id" class="mb-4 border-bottom pb-3">
          <h5>{{ client.name }} <small>({{ client.identifier }})</small></h5>
          <CInputCheckbox :checked.sync="client.enabled" label="Enabled" @update:checked="saveClient(client)" />
          <CInput v-model="client.scopesText" label="Scopes (comma-separated)" />
          <CButton size="sm" color="primary" @click="saveClient(client)">Save</CButton>
          <CButton size="sm" color="success" @click="issueApiKey(client)">Issue/rotate API key</CButton>
          <CButton size="sm" color="info" @click="issueAssertionKey(client)">Issue/rotate assertion secret</CButton>
          <h6 class="mt-3">API keys</h6>
          <div v-for="key in client.keys" :key="'api-'+key.id">
            {{ key.name }} / {{ key.key_identifier }} / last used: {{ key.last_used_at || 'never' }}
            <CButton v-if="!key.revoked_at" size="sm" color="danger" @click="revoke(client, key, false)">Revoke</CButton>
            <span v-else> (revoked)</span>
          </div>
          <h6 class="mt-2">Assertion keys</h6>
          <div v-for="key in client.assertion_keys" :key="'assertion-'+key.id">
            {{ key.name }} / kid={{ key.key_identifier }} / last used: {{ key.last_used_at || 'never' }}
            <CButton v-if="!key.revoked_at" size="sm" color="danger" @click="revoke(client, key, true)">Revoke</CButton>
            <span v-else> (revoked)</span>
          </div>
        </div>
      </CCardBody>
    </CCard>
    <CModal title="Add integration client" :show.sync="showCreate">
      <CInput v-model="form.name" label="Name" />
      <CInput v-model="form.identifier" label="Stable identifier" />
      <CInput v-model="form.assertion_issuer" label="Assertion issuer" />
      <CInput v-model="form.assertion_audience" label="Assertion audience" />
      <CInput v-model="form.scopesText" label="Scopes" />
      <template #footer>
        <CButton color="secondary" @click="showCreate=false">Cancel</CButton>
        <CButton color="success" @click="createClient">Create</CButton>
      </template>
    </CModal>
  </div>
</template>

<script>
import axios from 'axios'

const auth = () => ({ params: { token: localStorage.getItem('api_token') } })
export default {
  name: 'IntegrationClients',
  data () {
    return {
      clients: [], showCreate: false, oneTimeSecret: '', oneTimeLabel: '',
      form: { name: '', identifier: '', assertion_issuer: '', assertion_audience: 'ace-artwork-api', scopesText: 'customer-artwork:read' }
    }
  },
  mounted () { this.load() },
  methods: {
    load () {
      axios.get(this.$apiAdress + '/api/admin/integration-clients', auth()).then(({ data }) => {
        this.clients = data.map(c => Object.assign(c, { scopesText: (c.scopes || []).join(',') }))
      })
    },
    payload (client) { return { name: client.name, enabled: client.enabled, scopes: client.scopesText.split(',').map(s => s.trim()).filter(Boolean), assertion_issuer: client.assertion_issuer, assertion_audience: client.assertion_audience } },
    createClient () {
      const payload = Object.assign(this.payload(this.form), { identifier: this.form.identifier, enabled: true })
      axios.post(this.$apiAdress + '/api/admin/integration-clients', payload, auth()).then(() => { this.showCreate = false; this.load() })
    },
    saveClient (client) { axios.patch(this.$apiAdress + '/api/admin/integration-clients/' + client.id, this.payload(client), auth()).then(() => this.load()) },
    issueApiKey (client) {
      const name = window.prompt('Key name (for example, production-2026-10)')
      if (name) axios.post(this.$apiAdress + '/api/admin/integration-clients/' + client.id + '/keys', { name }, auth()).then(({ data }) => { this.oneTimeLabel = 'API key'; this.oneTimeSecret = data.plain_text_key; this.load() })
    },
    issueAssertionKey (client) {
      const name = window.prompt('Assertion key name')
      if (name) axios.post(this.$apiAdress + '/api/admin/integration-clients/' + client.id + '/assertion-keys', { name }, auth()).then(({ data }) => { this.oneTimeLabel = 'Assertion signing secret; kid=' + data.key.key_identifier; this.oneTimeSecret = data.plain_text_signing_secret; this.load() })
    },
    revoke (client, key, assertion) {
      if (!window.confirm('Revoke this key?')) return
      const segment = assertion ? 'assertion-keys' : 'keys'
      axios.post(this.$apiAdress + '/api/admin/integration-clients/' + client.id + '/' + segment + '/' + key.id + '/revoke', {}, auth()).then(() => this.load())
    }
  }
}
</script>
